<template>
  <div class="suggestion w1400">
    <div class="suggestion-title font20">
      <span> 当前位置：关于平台 > 意见建议</span>
      <div class="search">
        <el-input v-model="select_word"  clearable placeholder="请输入手机号码" class="handle-input mr10"></el-input>
        <el-button type="primary" icon="search" @click="search">搜索</el-button>
      </div>
    </div>
    <div class="suggestion-cont">
      <div class="suggest-text">
        <!-- 非常感谢您对本平台的支持，您的意见和建议是我们改进的方向！ -->
        <div class="color thank bold"></div>
        <div class="textsub">
          <div class="inputitem">
            <div class="font20">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名:</div>
            <input type="text" v-model="form.tt004"/>
          </div>
          <div class="inputitem mt25">
            <div class="font20">联系方式:</div>
            <input type="text" v-model="form.tt005"/>
          </div>
          <div class="inputitem mt25">
            <div class="font20" style="align-self: flex-start">意见建议内容:</div>
            <textarea name="" id="" cols="30" rows="10" class="textarea" v-model="form.tt003"></textarea>
          </div>
          <div class="form-btn" @click="submitSug">提交</div>
        </div>
      </div>
    </div>
<!--    历史意见-->
    <el-dialog  :visible.sync="dialogTableVisible">
      <el-table :data="gridData" border>
        <el-table-column property="tt001" label="单号"></el-table-column>
        <el-table-column property="tt002" label="日期">
          <template slot-scope="scope">
              {{scope.row.tt002 | formatTime}}
          </template>
        </el-table-column>
        <el-table-column property="tt003" label="意见内容"></el-table-column>
        <el-table-column property="tt008" label="回复日期"></el-table-column>
        <el-table-column property="tt009" label="回复意见">
          <template slot-scope="scope">
            {{scope.row.tt006==1?scope.row.tt009 :'待回复'}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      select_word: '',
      dialogTableVisible:false,
      gridData:[]
    }
  },
  methods: {
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "h+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "s+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
      }
      return fmt;
    },
    search() {
      if(this.select_word.trim()){
        this.$axios.post('/api/suggest/list', {
          where:` and tt005='${this.select_word}' and isdelete=0`,
        }).then(res => {
          if(res.data.code==200 && res.data.data.length>0){
            let data = res.data.data;
            for (let i = 0; i <data.length ; i++) {
              data[i].tt008 = data[i].tt006==1? this.dateFormat('yyyy/mm/dd', new Date(data[i].tt008)) : '';
            }
            this.gridData = data;
            this.dialogTableVisible = true;
          }else{
            this.$notify({
              title: '搜索',
              message: '没有找到相关记录',
              type: 'success'
            });
          }
        })
      }else{
        return;
      }
    },
    submitSug() {
      this.$axios.post('/api/suggest/insert', this.form).then(res => {
        if (res.data.code == 200) {
          this.$notify({
            title: '成功',
            message: '感谢您宝贵的建议',
            type: 'success'
          });
        }
      })
    }
  }

}
</script>

<style scoped>
.suggestion-title {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 7rem;
  line-height: 7rem;
  padding-left: 2.7rem;
  padding-right: 74px;
  background-color: #F6F5F5;
}
.search{
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.suggestion-cont {
  padding: 0 74px;
  height: 84.9rem;
  background-color: #F6F5F5;
}

.suggest-text {
  width: 100%;
  height: 71.5rem;
  background-color: white;
  overflow: hidden;
}

.thank {
  margin: 5.5rem auto 3.5rem;
  text-align: center;
  font-size: 2.5rem;
}

.textsub {
  padding: 0 27.5rem 0;
}

.inputitem {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.inputitem > div {
  width: 15rem;
  text-align: right;
  margin-right: 1.6rem;
}

.inputitem > input {
  display: block;
  width: 34.8rem;
  height: 4rem;
}

.mt25 {
  margin-top: 2.5rem;
}

.textarea {
  display: block;
  height: 30.6rem;
  width: 47.8rem;
}

textarea:focus, input:focus {
  outline: 1px solid #0083CE;
}

.form-btn {
  width: 170px;
  height: 4.8rem;
  line-height: 4.8rem;
  text-align: center;
  color: white;
  background-color: #0083CE;
  border-radius: 0.2rem;
  font-size: 1.6rem;
  letter-spacing: 0.5rem;
  margin: 4.5rem auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/page/suggestion.vue